import { KineticHero } from "@/components/home/KineticHero";
import { TrustBanner } from "@/components/home/TrustBanner";
import { Stats } from "@/components/home/Stats";
import { ProductsSection } from "@/components/home/ProductsSection";
import { Manufacturing } from "@/components/home/Manufacturing";
import { Community } from "@/components/home/Community";
import { Testimonials } from "@/components/home/Testimonials";
import { MadeInIndia } from "@/components/site/MadeInIndia";
import { DistributionSection } from "@/components/site/DistributionSection";
import { CTASection } from "@/components/site/CTASection";

export default function Home() {
  return (
    <div data-testid="home-page">
      <KineticHero />
      <TrustBanner />
      <Stats />
      <MadeInIndia />
      <ProductsSection />
      <Manufacturing />
      <DistributionSection />
      <Community />
      <Testimonials />
      <CTASection />
    </div>
  );
}
